import posthog from "posthog-js";
import {config} from 'app/config';
if (typeof window !== 'undefined') {
    posthog.init(String(config.posthog_api_key), {
        api_host: "https://eu.i.posthog.com",
        defaults: "2025-05-24",
        person_profiles: "identified_only",
        autocapture: true, // включить автосбор событий (по умолчанию true)
        capture_pageview: true, // включить трекинг pageview (SPA-friendly)

        capture_pageleave: false,
        cross_subdomain_cookie: true,
        enable_recording_console_log: false,
        disable_session_recording: true,
        disable_surveys: true,
        enable_heatmaps: false,
        disable_scroll_properties: true,
        disable_web_experiments: true,
        rageclick: false,
        capture_heatmaps: false,
        capture_dead_clicks: false,
        capture_performance: {
            web_vitals: false,
        },
    });
}